import { setAppCode, setPlatformCode } from '@micun/web-components'

setAppCode('ec')
setPlatformCode('web')
